<template>
  <ProgressCircular v-if="loading" />
  <form v-else novalidate :disabled="disabled" @submit.prevent="() => {}">
    <v-row no-gutters>
      <v-col cols="8">
        <v-card max-width="1200px" flat color="transparent">
          <v-card-title>
            <FormHeader
              :loading="loading"
              :disabled="disabled"
              link="page-personal-details"
              title="Редактировать анкету физ. лица"
            />
          </v-card-title>
          <v-card-text>
            <PageContent height="90">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <span>Фамилия*</span>
                    <v-text-field
                      id="surname"
                      v-model="fields.surname"
                      outlined
                      :value="''"
                      :autofocus="!fields.surname"
                      :error-messages="validationErrors.surname"
                      :loading="loading"
                      :disabled="disabled"
                      @input="$v.fields.surname.$touch()"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Имя*</span>
                    <v-text-field
                      v-model="fields.name"
                      id="name"
                      outlined
                      :value="''"
                      :autofocus="!fields.name"
                      :error-messages="validationErrors.name"
                      :loading="loading"
                      :disabled="disabled"
                      @input="$v.fields.name.$touch()"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Отчество</span>
                    <v-text-field
                      v-model="fields.patronymic"
                      outlined
                      :value="''"
                      :autofocus="!fields.patronymic"
                      :error-messages="validationErrors.patronymic"
                      :loading="loading"
                      :disabled="disabled"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Телефон*</span>
                    <v-text-field
                      v-model="fields.phone"
                      id="phone"
                      outlined
                      :value="''"
                      :autofocus="!fields.phone"
                      :error-messages="validationErrors.phone"
                      :loading="loading"
                      :disabled="disabled"
                      @input="$v.fields.phone.$touch()"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Эл.почта*</span>
                    <v-text-field
                      v-model="fields.email"
                      outlined
                      id="email"
                      :value="''"
                      :autofocus="!fields.email"
                      :error-messages="validationErrors.email"
                      :loading="loading"
                      :disabled="disabled"
                      @input="$v.fields.email.$touch()"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </PageContent>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <ManageSidePanel
          ref="manageSidePanel"
          :isLocales="false"
          :is-new="false"
          :created-at="data.createdAt"
          :updated-at="data.updatedAt"
          :is-loading="loading"
          :is-submit-disabled="disabled"
          :entity-id="data.id"
          :entity-type="'personalDetail'"
          @delete="$emit('delete-detail')"
          @cancel="$router.push({ name: 'page-personal-details' })"
          @submit="submit"
        />
      </v-col>
    </v-row>
  </form>
</template>

<script>
import FormAbstract from '@/components/abstract/form'
import ManageSidePanel from '@/components/manage-side-panel/ManageSidePanel'
import FormHeader from '@/components/form-header/FormHeader'
import validationRules from './validation-rules'
import PageContent from '@/components/page-content/PageContent.vue'
import ProgressCircular from '@/components/progress-circular'

export default {
  name: 'FormPersonalDetail',
  validationRules,
  components: { PageContent, FormHeader, ManageSidePanel, ProgressCircular },
  extends: FormAbstract,
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      personalDetail: {
        surname: null,
        name: null,
        patronymic: null,
        phone: null,
        email: null
      },
      fields: {
        surname: null,
        name: null,
        patronymic: null,
        phone: null,
        email: null
      }
    }
  },
  watch: {
    data (data) {
      this.populate(data)
      this.personalDetail = data.personalDetail
    }
  },
  methods: {
    async submit () {
      const isValid = await this.validate()
      if (!isValid) {
        this.mixScrollToError(this.$v)
        return
      }
      const payload = {
        ...this.composeFormData(this.fields)
      }
      delete payload.roles
      this.$emit('submit', payload)
    }
  }
}
</script>
